import React from 'react'
import { Select, Space } from 'antd'
import PropTypes from 'prop-types'
import { useSmartTranslation } from '../../cls/TranslationContext'
const { Option } = Select
/**
 * LanguageSelector allows users to switch the app language.
 * Renders either a dropdown selector or a horizontal list of buttons.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.label] – Translation key for an optional label when in list mode.
 * @param {'selector'|'list'} [props.type='selector'] – Render mode: 'selector' for dropdown, 'list' for buttons.
 * @returns {JSX.Element}
 */
const LanguageSelector = ({ label, type = 'selector' }) => {
	const { t, i18n } = useSmartTranslation()

	const changeLanguage = (value) => {
		i18n.changeLanguage(value)
	}

	if (type === 'selector') {
		return (
			<Select
				defaultValue={i18n.language} // Sets the currently selected language
				style={{ width: 120 }}
				onChange={changeLanguage}
			>
				<Option value="en">English</Option>
				<Option value="ro">Romanian</Option>
				{/* Add more languages as needed */}
			</Select>
		)
	} else if (type === 'list') {
		// return buttons on horizontal line, show curent selected language
		return (
			<Space style={{ width: '100%' }}>
				{label && <span>{t(label)}</span>}
				<div style={{ display: 'flex', gap: '0' }}>
					<button
						style={{
							backgroundColor:
								i18n.language === 'en' ? '#1890ff' : '#fff',
							color: i18n.language === 'en' ? '#fff' : '#000',
							border: 'unset',
							padding: '5px 10px',
							cursor: 'pointer'
						}}
						onClick={() => changeLanguage('en')}
					>
						EN
					</button>
					<button
						style={{
							backgroundColor:
								i18n.language === 'ro' ? '#1890ff' : '#fff',
							color: i18n.language === 'ro' ? '#fff' : '#000',
							border: 'unset',
							padding: '5px 10px',
							cursor: 'pointer'
						}}
						onClick={() => changeLanguage('ro')}
					>
						RO
					</button>
				</div>
			</Space>
		)
	}
}
LanguageSelector.propTypes = {
	label: PropTypes.string,
	type: PropTypes.string
}

export default LanguageSelector
